export type CommonDescriptionAttribute = {
  code: 'description';
  type?: 'text';
  title?: string;
  value: string | null;
  defaultValue?: string | null;
  displayValue?: string | null;
  extra?: any; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
  required?: boolean;
  override: boolean;
  hasPublishControl?: boolean;
  publish: boolean;
};
